import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import userReducer from './UserReducer';
import notificationReducer from './NotificationReducer';
import customerReducer from './CustomerReducer';
import { titleReducer, queryStringReducer } from './GlobalReducers';
import NotesReducer from './NotesReducer';
import AllUsersReducer from './AllUsersReducer';
import StatsReducer from './StatsReducer';
import ServiceReducer from './ServiceReducer';
import ProductReducer from './ProductReducer';
import ReportReducer from './ReportReducer';
import EmailReducer from './EmailReducer';
import SearchReducer from './SearchReducer';
import DevReducer from './DevReducer';
import ForexReducer from './ForexReducer';
import SystemReducer from './SystemReducer';

export default (history) => combineReducers({
  router: connectRouter(history),
  user: userReducer,
  notifications: notificationReducer,
  customers: customerReducer,
  pageTitle: titleReducer,
  query: queryStringReducer,
  notes: NotesReducer,
  allUsers: AllUsersReducer,
  stats: StatsReducer,
  services: ServiceReducer,
  products: ProductReducer,
  reports: ReportReducer,
  emails: EmailReducer,
  search: SearchReducer,
  systems: SystemReducer,
  dev: DevReducer,
  forex: ForexReducer
});
